import { render, staticRenderFns } from "./EditChargeIP.vue?vue&type=template&id=88173598&lang=pug"
import script from "./EditChargeIP.vue?vue&type=script&lang=js"
export * from "./EditChargeIP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports